import { IS_LOCAL } from '../../../../constants'
import { ApiService } from 'shared/http/v2/http.mixin'
import { allWarehouseTypes } from '../store'
import { fakeWarehouses } from './fake'
import {
  buildWarehouseByPatternArgs,
  WarehouseByPatternArgs,
  WarehouseByPatternResponse,
} from './types'
import { HttpStatusCode } from 'axios'

export class WarehouseAPI extends ApiService({ basePath: '/warehouses', apiVersion: 'v2' }) {
  public static async searchByPattern(
    args: WarehouseByPatternArgs = { pattern: '', warehouseTypes: allWarehouseTypes }
  ): Promise<WarehouseByPatternResponse> {
    if (IS_LOCAL) {
      return (await fakeWarehouses(args.pattern)).data
    }

    const resp = await this.http.get<WarehouseByPatternResponse>('/', {
      query: buildWarehouseByPatternArgs(args),
    })

    if (resp.status === HttpStatusCode.NotFound) {
      return []
    }

    if (resp.status !== 200) {
      throw new Error(resp.error)
    }

    return resp.data
  }
}
